import { FC } from 'react';
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai';
import {
  Box,
  ButtonGroup,
  Flex,
  FlexProps,
  Icon,
  IconButton,
  NativeSelect,
  Stack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';

import { ApiPaginationMetaResponse } from '~/core/shared/types';

type PaginationProps = FlexProps & {
  meta: ApiPaginationMetaResponse;
  gotoPage?: (number: number) => void;
  previousPage: () => void;
  nextPage: () => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
};

export const Pagination: FC<PaginationProps> = ({
  meta,
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
}) => {
  const isMobileBreakpoint = useBreakpointValue({
    base: true,
    lg: false,
  });

  const getPaginationOptions = (itemCount: number) => {
    const content = [];
    for (let i = 1; i <= itemCount; i += 1) {
      content.push(
        <option key={i} value={i}>
          {i}
        </option>,
      );
    }
    return content;
  };

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      mt="12px"
      pr={0}
      width="100%"
    >
      <Flex fontSize="14px" gap={1}>
        <Text display={isMobileBreakpoint ? 'none' : 'block'}>Displaying</Text>
        <Text>
          {meta.from} - {meta.to}
        </Text>
        <Text color="gray.600">(of {meta.total})</Text>
      </Flex>
      <Stack alignItems="center" direction="row">
        {gotoPage && (
          <Flex
            alignItems="center"
            bg="white"
            direction="row"
            h="44px"
            position="relative"
            pr={5}
            right="-19px"
            width={isMobileBreakpoint ? '100%' : 'inherit'}
          >
            <NativeSelect.Root color="navy.500" lineHeight="10px" w="83px">
              <NativeSelect.Field
                bg="transparent"
                border="none"
                onChange={(value) => {
                  gotoPage(
                    value.target.value ? Number(value.target.value) - 1 : 0,
                  );
                }}
                value={meta.currentPage}
              >
                {getPaginationOptions(meta.lastPage)}
              </NativeSelect.Field>
              <NativeSelect.Indicator />
            </NativeSelect.Root>

            <Text>of {meta.lastPage} </Text>
          </Flex>
        )}

        <ButtonGroup>
          <IconButton
            aria-label="prev"
            bg="white"
            borderRadius="0"
            disabled={!canPreviousPage}
            h="44px"
            m={0}
            marginInlineStart={0}
            onClick={() => previousPage()}
            position="relative"
            right="-9px"
            w="44px"
          >
            <Icon as={AiFillCaretLeft} boxSize={4} />
          </IconButton>
          <IconButton
            aria-label="prev"
            bg="white"
            borderRadius="0"
            disabled={!canNextPage}
            h="44px"
            m={0}
            marginInlineStart={0}
            onClick={() => nextPage()}
            w="44px"
          >
            <Icon as={AiFillCaretRight} boxSize={4} />
          </IconButton>
        </ButtonGroup>
      </Stack>
    </Flex>
  );
};
